import {Alert, Button, Form, Modal, ProgressBar} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";
import React, {useState} from "react";
import {useAuth} from "../../authprovider";
import { useTranslation } from 'react-i18next';

export default function AddVideoModal(props){
    const auth = useAuth();
    const [uploadProgress, setUploadProgress] = useState(0)
    const [disabled, setDisabled] = useState(false)
    const [alert, setAlert] = useState({
        show:false,
        content:"",
    })
    const { t } = useTranslation();

    const uploadProgressHandler = (event)=>{
        let percent = 0;
        let position = event.loaded || event.position;
        let total = event.total;
        if (event.lengthComputable) {
            percent = Math.ceil(position / total * 100);
        }

        setUploadProgress(percent*0.75);
    }

    const handleSubmit = (formEvent)=>{

        formEvent.preventDefault();
        formEvent.stopPropagation();

        const form = formEvent.currentTarget;

        //TODO: add error
        if(form.video.files.length <= 0)
            return;

        if(form.category.value.length <= 0)
            return;

        if(form.name.value.length <= 0)
            return;

        setDisabled(true);

        const formData = new FormData();
        formData.append('video', form.video.files[0]);
        formData.append('name', form.name.value);
        formData.append('category', form.category.value);

        auth.videos.add(formData, uploadProgressHandler, response=>{
            const {success, error, content} = response;

            if(success === true){
                props.onHide(content);
            } else {
                window.alert(error)
                console.log(error);
            }
            setDisabled(false);
            setUploadProgress(0)
        })


    }

    const hideAlert = ()=>{
        setAlert({show:false, content: ""})
    }

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {t('videos.uploadModalTitle')}
                </Modal.Title>
            </Modal.Header>
            <Form disabled noValidate  action={"post"} onSubmit={handleSubmit} >
                <Modal.Body>
                    <Alert show={alert.show} variant={"warning"} onClose={hideAlert} dismissible>
                        <p>
                            {alert.content}
                        </p>
                    </Alert>
                    <Form.Group className="mb-3" controlId="videoName">
                        <Form.Label>{t('videos.fileLabel')}</Form.Label>
                        <Form.Control  disabled={disabled} type="file" name={"video"} accept={"video/*"} />
                        <Form.Text className="text-muted" >
                            {t('videos.fileHelp')}
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="videoName">
                        <Form.Label>{t('videos.nameLabel')}</Form.Label>
                        <Form.Control  disabled={disabled} type="text" name={"name"} placeholder={t('videos.namePlaceholder')}  />
                        <Form.Text className="text-muted" >
                            {t('videos.nameHelp')}
                        </Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="videoCategory">
                        <Form.Label>{t('videos.categoryLabel')}</Form.Label>
                        <Form.Select disabled={disabled} name={"category"}  aria-label="Select video category">
                            <option value="KPP">{t('videos.categoryKpp')}</option>
                            <option value="PPOZ">{t('videos.categoryPpoz')}</option>
                        </Form.Select>
                    </Form.Group>

                </Modal.Body>
                <Modal.Footer>
                    {
                        disabled &&
                        <div className={"w-100"}>
                            <ProgressBar animated  now={uploadProgress} label={`${uploadProgress}%`} />
                            <small>{t('videos.uploadProgressInfo')}</small>
                        </div>

                    }
                    <Button disabled={disabled} type={"submit"} name={"Prześlij"}>
                        {disabled ? <FontAwesomeIcon icon={faSpinner}  spin/> : t('videos.upload') }
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}